import { styled } from '@mui/material';

import { linkable } from '../../routing';
import { colorSystem } from '../../theme';
import { BaseIconButton, LinkIconButton } from './BaseIconButton';

const destructiveSecondaryIconButtonStyle = {
    background: colorSystem.neutral.white,
    color: colorSystem.neutral[7],
    border: `1px solid ${colorSystem.neutral[3]}`,
    borderRadius: '4px',

    '&:hover': {
        color: colorSystem.red[7],
        background: colorSystem.red[1],
        border: `1px solid ${colorSystem.red[3]}`,
    },
    '&:active': {
        background: colorSystem.red[2],
        color: colorSystem.red[7],
        border: `1px solid ${colorSystem.red[3]}`,
    },
    '&:disabled': {
        background: colorSystem.neutral.white,
        color: colorSystem.neutral[5],
        border: `1px solid ${colorSystem.neutral[4]}`,
    },
};

const DestructiveSecondaryIconButtonHost = styled(BaseIconButton)(destructiveSecondaryIconButtonStyle);
const DestructiveSecondaryIconButtonLinkHost = styled(LinkIconButton)(destructiveSecondaryIconButtonStyle);

export const DestructiveSecondaryIconButton = linkable(DestructiveSecondaryIconButtonHost, {
    linkHost: DestructiveSecondaryIconButtonLinkHost,
});
